module.exports = __webpack_public_path__ + "4b7b527d2379c0145e98ee6641ae93b3.MP3";